import styled from 'styled-components';

import { BaseStyle, Button } from '@nhl/nhl-breakaway-ui';

const ADD_BUTTON_WIDTH = 40;

export const InputsContainer = styled.form`
    display: grid;
    grid-template-columns: 2fr 1fr 1fr ${ADD_BUTTON_WIDTH}px;
    grid-gap: ${BaseStyle.GAP_SIZES.extraSmall}px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-template-columns: 50% 2fr 1fr ${ADD_BUTTON_WIDTH}px;
    }

    ${BaseStyle.Mixins.screenSizes.smallerThanMedium} {
        .MuiInput-root {
            padding-left: 12px;

            .MuiInput-input {
                min-width: 22px;
                padding: 0;
            }

            .MuiInputAdornment-root {
                margin-left: 8px;
            }

            button {
                width: 40px;
            }
        }
    }
`;

export const ValueInput = styled.input.attrs({
    type: 'text',
})`
    border: 1px solid ${({ theme }) => theme.Surface.border};
    display: block;
    padding: 10px;
    height: 44px;
    width: 100%;

    &:disabled {
        background: ${({ theme }) => theme.Surface.disabled};
    }
`;

export const AddButton = styled(Button)`
    ${BaseStyle.Mixins.fontStyles.ui['16m']};
    height: 44px;
    max-width: ${ADD_BUTTON_WIDTH}px;
    padding: 20px;
`;
